/* global angular */

require('../number-float-input/number-float-input.component.js')

angular.module('NumberFloatInputPlusMinusCmp', ['NumberFloatInputCmp'])
  .component('numberFloatInputPlusMinus', {
    template: require('./number-float-input-plus-minus.component.tpl.html'),
    controller: NumberFloatInputPlusMinusCtrl,
    controllerAs: 'vm',
    bindings: {
      value: '=',
      defaultValue: '<',
      precision: '<',
      ngMin: '<',
      ngMax: '<',
      ngDisabled: '<',
      onInputChanged: '&',
      onMinus: '&',
      onPlus: '&',
      ngModelOptions: '<',
      inputClass: '<',
      labelText: '@',
      inputRf: '@',
      minusRf: '@',
      plusRf: '@',
      allowEmpty: '@',
      resetCallbackFn: '&',
      trackElement: '@'
    }
  })

NumberFloatInputPlusMinusCtrl.$inject = []

function NumberFloatInputPlusMinusCtrl () {
  var vm = this

  vm.$onInit = function () {
    vm.ngModelOptions = vm.ngModelOptions || {}
  }

  vm.$onChanges = function (changesObj) {
    if (changesObj.ngModelOptions) {
      vm.ngModelOptions = vm.ngModelOptions || {}
    }
  }
}
